export const insights = {
    "structure": [
        {
	"view": "welcome",
	        "props": {
	            "logo_url": "https:\/\/global--assets.s3.eu-west-2.amazonaws.com\/production\/survey-assets\/741\/welcome_image-a53e9d40-2a49-411f-a6ff-b815ffde6f7c.png",
	            "title": "Show your support for the transformation of Forth Goods Yard",
	            "subtitle": null,
	            "description": "Newcastle City Council is considering an application submitted by Platform4 and blocwork, that would see the transformation of Newcastle's historic Forth Goods Yard into a landmark new neighbourhood, offering new homes and public spaces at its heart (2025\/2088\/01\/EIA).&#x20;\n\n**This form will help you generate a letter of support that will be passed on to the council.**&#x20;\n\n[If you prefer, you can view the plans and comment directly on Newcastle City Council's website by clicking here.](https:\/\/portal.newcastle.gov.uk\/planning\/index.html?fa=getApplication\\&id=324330) Please note, to comment directly on the Council's website you will need to login to provide a comment on the application.\n\n[More information about the proposals is available on the project website, click here to find out more.](https:\/\/forthgoodsyard.co.uk\/)",
	            "client_name": "Bloc",
	            "client_email": "James.Verfuerth@platform4.com",
	            "client_phone": null,
	            "client_privacy": "https:\/\/platform4.com\/privacy-notice\/"
	        }
	    },
	    {
	        "view": "steps",
	        "props": {
	            "steps": [
	            {
	                "id": "8d405dc2-bb47-4bf7-845f-a12adb7dbe04",
	                "key": "Please confirm if you are responding as an individual or on behalf of an organisation?",
	                "step": "question",
	                "type": "choice",
	                "other": false,
	                "title": "Please confirm if you are responding as an individual or on behalf of an organisation?",
	                "answers": [
	                {
	                    "label": "Individual",
	                    "value": "Individual",
	                    "image_url": null
	                },
	                {
	                    "label": "Organisation",
	                    "value": "Organisation",
	                    "image_url": null
	                }
	                ],
	                "shuffle": false,
	                "required": false,
	                "instruction": "Question 1 of 3&#x20;",
	                "max_answers": 1,
	                "min_answers": 1
	            },
	            {
	                "id": "e3e0319d-f327-4007-abae-678d66c0c042",
	                "key": "Please confirm the organisation you are responding on behalf of",
	                "step": "question",
	                "type": "paragraph",
	                "title": "Please confirm the organisation you are responding on behalf of",
	                "required": false,
	                "conditional": {
	                    "conditionGroups": [
	                    {
	                        "conditions": [
	                        {
	                            "answers": [
	                            "Organisation"
	                            ],
	                            "question": "8d405dc2-bb47-4bf7-845f-a12adb7dbe04",
	                            "conditionStatus": "show"
	                        }
	                        ]
	                    }
	                    ]
	                },
	                "max_characters": 1000
	            },
	            {
	                "id": "70ddffea-8460-405c-b66b-16c2c5c89764",
	                "key": "As a reminder, the proposals offer:",
	                "step": "info",
	                "type": "gallery",
	                "title": "As a reminder, the proposals offer:",
	                "images": [
	                {
	                    "image": "https:\/\/global--assets.s3.eu-west-2.amazonaws.com\/production\/survey-assets\/741\/gallery-70ddffea-8460-405c-b66b-16c2c5c89764-image-0-78018345-3aba-4c45-9000-38652fea36c8.jpg",
	                    "caption": null
	                },
	                {
	                    "image": "https:\/\/global--assets.s3.eu-west-2.amazonaws.com\/production\/survey-assets\/741\/gallery-70ddffea-8460-405c-b66b-16c2c5c89764-image-1-f9109c96-9b5c-4f51-bea9-a4495e2d3c36.jpg",
	                    "caption": null
	                },
	                {
	                    "image": "https:\/\/global--assets.s3.eu-west-2.amazonaws.com\/production\/survey-assets\/741\/gallery-70ddffea-8460-405c-b66b-16c2c5c89764-image-2-d87ddfe3-5bd8-42c1-bc80-7b4bc10b9087.jpg",
	                    "caption": null
	                },
	                {
	                    "image": "https:\/\/global--assets.s3.eu-west-2.amazonaws.com\/production\/survey-assets\/741\/gallery-70ddffea-8460-405c-b66b-16c2c5c89764-image-3-48bd62ab-adf1-4d8c-a26a-2aea31808d94.jpg",
	                    "caption": null
	                },
	                {
	                    "image": "https:\/\/global--assets.s3.eu-west-2.amazonaws.com\/production\/survey-assets\/741\/gallery-70ddffea-8460-405c-b66b-16c2c5c89764-image-4-862efddf-b660-4a05-876a-d469d18cf0ca.jpg",
	                    "caption": null
	                },
	                {
	                    "image": "https:\/\/global--assets.s3.eu-west-2.amazonaws.com\/production\/survey-assets\/741\/gallery-70ddffea-8460-405c-b66b-16c2c5c89764-image-5-16543159-d319-44a9-aba0-e36d4d072238.jpg",
	                    "caption": null
	                },
	                {
	                    "image": "https:\/\/global--assets.s3.eu-west-2.amazonaws.com\/production\/survey-assets\/741\/gallery-70ddffea-8460-405c-b66b-16c2c5c89764-image-6-0889d427-fc38-4f86-8a85-30baf43f5361.jpg",
	                    "caption": null
	                }
	                ],
	                "description": "- 514 new, high-quality homes across two residential buildings\n\n- New green space and public realm across the site, benefitting the wider community and significantly improving biodiversity\n\n- 650 new car parking spaces for station customers and city centre visitors\n\n- A new highline walking route connecting Newcastle Station to the west of the City\n\n- New retail and amenity space, creating a vibrant mixed-use community\n\nThe project will also act as an enabler for delivery of up to 2,500 homes at Forth Yards, plus re-configuration for the wider Newcastle station (with air quality benefits, reduced congestion and an improved customer parking experience)."
	            },
	            {
	                "id": "aa808352-4d2d-4612-8f6e-0d767083c801",
	                "key": "I support the plans because...",
	                "step": "question",
	                "type": "paragraph",
	                "title": "I support the plans because...",
	                "required": true,
	                "instruction": "Question 2 of 3&#x20;\n\nPlease tell us why you support our plans to transform Forth Goods Yard - you can say as little or as much as you like!\n\nYour comments will then be turned into an email, which will be sent directly to Newcastle City Council's planning department. You will be able to review and edit the final email before sending.&#x20;",
	                "max_characters": 5000
	            },
	            {
	                "id": "2b878f78-a3d6-4500-8b62-819e9ff42332",
	                "key": "Your details",
	                "step": "question",
	                "type": "form",
	                "title": "Your details",
	                "fields": [
	                {
	                    "key": "First Name",
	                    "type": "text",
	                    "label": "First Name",
	                    "personal": true,
	                    "required": true
	                },
	                {
	                    "key": "Last Name",
	                    "type": "text",
	                    "label": "Last Name",
	                    "personal": true,
	                    "required": true
	                },
	                {
	                    "key": "House Number \/ Street",
	                    "type": "text",
	                    "label": "House Number \/ Street",
	                    "personal": true,
	                    "required": true
	                },
	                {
	                    "key": "City",
	                    "type": "text",
	                    "label": "City",
	                    "personal": true,
	                    "required": true
	                },
	                {
	                    "key": "Postcode",
	                    "type": "text",
	                    "label": "Postcode",
	                    "personal": true,
	                    "required": true
	                },
	                {
	                    "key": "Email",
	                    "type": "email",
	                    "label": "Email",
	                    "personal": true,
	                    "required": true
	                },
	                {
	                    "key": "Phone Number",
	                    "type": "tel",
	                    "label": "Phone Number",
	                    "personal": true,
	                    "required": true
	                }
	                ],
	                "instruction": "Question 3 of 3 (100% complete)\n\nYou will need to provide your full name and address for your comments to be properly logged by the council"
	            }
	            ]
	        }
	    },
	    {
	        "view": "email",
	        "props": {
	            "subject": "Support for regeneration proposals at Forth Goods Yard - 2025\/2088\/01\/EIA",
	            "to": "planning.control@newcastle.gov.uk",
	            "bcc": "north@consultation-online.co.uk",
	            "body": "For the attention of Jon Rippon\/Newcastle City Council, \n\nI am writing to register my support for proposals progressed by blocwork and Platform4 for the transformation of Forth Goods Yard, that would see the development of over 500 new, high-quality homes, a new public highline and a multi-storey car park offering 650 parking spaces. \n\n{{I support the plans because...}}\n\nI confirm that this letter can be uploaded to the planning case file as formal support for the application. \n\nKind Regards, \n{{First Name}} {{Last Name}}\n{{House Number \/ Street}}\n{{City}}\n{{Postcode}}\n{{Email}}"
	        }
	    },
	    {
	        "view": "submit",
	        "props": {
	            "title": "Submit your answers",
	            "statement": null,
	            "logo_url": null,
	            "privacy_link": "https:\/\/platform4.com\/privacy-notice\/",
	            "terms_link": null,
	            "captcha": false,
	            "agreements": [
	            {
	                "label": "I agree to the privacy policy and confirm I'm over 13 years old.",
	                "key": "I agree to the privacy policy and confirm I'm over 13 years old.",
	                "required": true
	            }
	            ]
	        }
	    },
	    {
	        "view": "thanks",
	        "props": {
	            "title": "Thank you for submitting a comment on the planning application",
	            "statement": "[If you would like to receive updates on the proposals as they progress, please join our mailing list by clicking the link here.](https:\/\/forthgoodsyard.co.uk\/find-out-more\/)",
	            "more_statement": null,
	            "more_url": null,
	            "more_button_text": "Find out more",
	            "share": false
	        }
        },
    ],
    "actions":{
        data(data){
            console.log("Submitting Data", data);
			return JSON.stringify(data);
        },
        interaction(type, label, target){
            console.log("Interaction", type, label, target)
        },
        progress(status){
            console.log("progress", status)
			return fetch("/actions/data", {
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				method: "POST",
				body: JSON.stringify(status),
			});
        },
    },
	"lang": "en-gb",
	"status": 'Live',
	"progressbar": false,
	"layout": 'Horizontal',
}
